import React, { useMemo, useState } from "react";
import useApi from "../../hooks/useApi";
import { Box, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import DeleteAssignmentDialog from "./DeleteAssignmentDialog";
import { historyTableColumns, pathMappings } from "./constants";
import GoBack from "./GoBack";
import Pagination from "../../components/Common/Pagination/Pagination";
import usePagination from "../../hooks/usePagination";
import CommunicationHub from "../../services/api/CommunicationHub";
import { useParams } from "react-router-dom";
import useOptions from "./hooks/useOptions";
import LoadingComponent from "./LoadingComponent";
import ErrorComponent from "./ErrorComponent";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import Permission from "../Common/Permission";
import { useLocation } from "react-router-dom";

const History = () => {
  const { tag, id } = useParams();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const title = params.get("title");
  const { handlePagination, page, perPage } = usePagination();
  const {
    options,
    error: optionsError,
    isLoading: isOptionsLoading,
  } = useOptions();
  const { data, isLoading, error, refetch } = useApi({
    queryKey: [page, perPage],
    queryFn: () =>
      CommunicationHub.getAssignHistory({
        element_type: pathMappings[tag],
        element_id: id,
        page_request: {
          page,
          page_size: perPage,
        },
      }),

    initialData: {
      page_response: {
        previous_page: -1,
        next_page: -1,
        items_count: 1,
      },
      entity_mappings: [],
    },
  });
  const allActions = MenuActionsMappings[MenuNames.COMMUNICATION_HUB];

  const [selectedRows, setSelectedRows] = useState([]);

  const columns = useMemo(() => {
    return historyTableColumns(options);
  }, [options]);

  if (isOptionsLoading || isLoading) return <LoadingComponent />;
  if (error || optionsError) return <ErrorComponent />;

  return (
    <Box height={"100%"}>
      <Box display={"flex"} mb={2} justifyContent={"space-between"} gap={2}>
        <Box>
          <GoBack title={title} />
        </Box>

        <Permission requiredPerms={[allActions.COMMUNICATION_HUB_ASSIGN]}>
          <DeleteAssignmentDialog
            selectedRows={selectedRows}
            callback={refetch}
          />
        </Permission>
      </Box>
      {data === null ? (
        <Typography variant="body1">No Data to show</Typography>
      ) : (
        <Box sx={{ height: "84%" }}>
          <DataGrid
            columns={columns}
            rows={data?.entity_mappings ?? []}
            checkboxSelection
            rowSelectionModel={selectedRows}
            onRowSelectionModelChange={setSelectedRows}
            hideFooter
            loading={isLoading}
          />
          <Pagination
            page={page - 1}
            perPage={perPage}
            previousPage={data?.page_response?.previous_page ?? -1}
            nextPage={data?.page_response?.next_page ?? -1}
            onPageChange={handlePagination}
          />
        </Box>
      )}
    </Box>
  );
};

export default History;
